import Joi from "joi-browser";

const SharesForm = Joi.object({
    neospectraShare: Joi.number().positive().max(100).required(),
    partnerShare: Joi.number().positive().max(100).required(),
    isReseller: Joi.object().required(),
    reseller: Joi.when(Joi.ref("$isReseller"), {
        is: true,
        then: Joi.object().required(),
    }),
    resellerShare: Joi.when(Joi.ref("$isReseller"), {
        is: true,
        then: Joi.number().positive().max(100).required(),
    }),
});

export default { SharesForm };
